import { useLocation } from 'react-router-dom';

const usePageName = () => {
    const url = useLocation();
    const page = url.pathname.split('/').pop()?.split('?')[0];

    return page;
};

export default usePageName;
